import React from "react";

export default ({classes}) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 5.289 5.292" className={classes.root}>
        <path
            d="M1.092 0L.614.956.606.964l.003.003-.34.678L1.962.926a1.099 1.099 0 01-.348-.133A2.116 2.116 0 014.76 2.756l.526.027A2.644 2.644 0 004.298.58 2.648 2.648 0 001.23.41 1.054 1.054 0 011.092 0zM.012 2.38a2.644 2.644 0 004.052 2.496c.077.124.13.265.15.416l.465-.962.008-.008-.004-.003.33-.684-1.681.744c.12.022.233.063.336.12A2.116 2.116 0 01.537 2.432L.013 2.38z"/>
    </svg>
);